import React, { useState, useMemo } from 'react';
import Select from 'react-select';
import ReactPaginate from 'react-paginate';
import { categories } from '../../helpers/constants';
import { BiRightArrowAlt, BiLeftArrowAlt } from 'react-icons/bi';

// HOOKS
import useCampaign from '../../hooks/useCampaign';

// COMPONENTS
import PageBanner from '../../components/general/PageBanner';
import FundraiseCard from '../../components/general/FundraiseCard';

function CampaignsPage() {
    const { allCampaigns } = useCampaign();
    const [categoryFilter, setCategoryFilter] = useState({ label: 'All', value: 'All' });
    const [dateFilter, setDateFilter] = useState({ label: 'Newest First', value: 'newest' });

    /* --------------------------------------------------- 
          CHANGE RENDERD CAMPAIGNS ACCORDING TO FILTERs
    --------------------------------------------------- */
    const filteredResult = useMemo(() => {
        if (categoryFilter?.value === 'All') {
            return allCampaigns;
        } else if (categoryFilter?.value !== 'All') {
            return allCampaigns?.filter((camp) => camp.category === categoryFilter?.value);
        } else {
            return allCampaigns;
        }
        // eslint-disable-next-line
    }, [categoryFilter, dateFilter, allCampaigns]);

    function handleDateFilter(val) {
        setDateFilter(val);
    }

    // PAGINATION VARIABLES ---------------------------------
    const [itemOffset, setItemOffset] = useState(0);
    const itemsPerPage = 12;
    const endOffset = itemOffset + itemsPerPage;
    const pageCount = Math.ceil(allCampaigns?.length / itemsPerPage);

    /* --------------------------------------------- 
          MOVE BETWEEN PAGES
    --------------------------------------------- */
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % allCampaigns?.length;
        setItemOffset(newOffset);
    };

    return (
        <>
            <PageBanner
                heading='All Campaigns'
                text='Lorem ipsum dolor sit amet consectetur adipisicing elit. Quae, similique pariatur et corporis'
            ></PageBanner>
            <section className='pb-5 z-index-20'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-8 mx-auto' data-aos='fade-up'>
                            <ul className='list-inline d-flex justify-content-center flex-wrap z-index-20'>
                                <li className='list-inline-item me-3 my-2'>
                                    <label htmlFor='categoryFilter' className='form-label'>
                                        Filter by Category
                                    </label>

                                    <Select
                                        options={[
                                            { label: 'All', value: 'All' },
                                            ...categories?.map((ct) => ({
                                                label: ct?.label,
                                                value: ct?.value,
                                            })),
                                        ]}
                                        className='border-0 shadow-sm'
                                        classNamePrefix='select'
                                        placeholder='Select'
                                        onChange={setCategoryFilter}
                                        isSearchable={false}
                                        value={categoryFilter}
                                        autosize={true}
                                    />
                                </li>
                                <li className='list-inline-item me-3 my-2'>
                                    <label htmlFor='dateSort' className='form-label'>
                                        Sort by Date
                                    </label>

                                    <Select
                                        options={[
                                            { label: 'Newest First', value: 'newest' },
                                            { label: 'Oldest First', value: 'oldest' },
                                        ]}
                                        className='border-0 shadow-sm'
                                        classNamePrefix='select'
                                        placeholder='Select'
                                        onChange={(value) => handleDateFilter(value)}
                                        isSearchable={false}
                                        value={dateFilter}
                                        autosize={true}
                                    />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className='pb-5'>
                <div className='container pb-5'>
                    <div className='row justify-content-center gy-4'>
                        {filteredResult?.length > 0 ? (
                            filteredResult
                                .sort((a, b) => {
                                    if (dateFilter.value === 'newest') {
                                        return b?.id - a?.id;
                                    } else {
                                        return a?.id - b?.id;
                                    }
                                })
                                ?.slice(itemOffset, endOffset)
                                ?.map((camp) => {
                                    return (
                                        <div className='col-xxl-3 col-lg-4 col-md-6' key={camp.id}>
                                            <FundraiseCard {...camp} />
                                        </div>
                                    );
                                })
                        ) : (
                            <div className='col-12 text-center'>
                                <div className='d-inline-block'>
                                    <p className='glass-bg p-3 mb-0 text-center'>There're no campaigns at the moment</p>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* PAGINATION */}
                    {filteredResult?.length > 0 && (
                        <div className='react-pagination mt-4 justify-content-center'>
                            <ReactPaginate
                                breakLabel='...'
                                nextLabel={<BiRightArrowAlt />}
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={5}
                                pageCount={pageCount}
                                previousLabel={<BiLeftArrowAlt />}
                                renderOnZeroPageCount={null}
                            />
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}

export default CampaignsPage;
